import { Box, IconButton } from '@mui/material'
import { arrowRightSharpIcon } from '../../assets/index'
import { BUTTON_THEME_COLOR, BUTTON_TRANSITION } from '../../theme/buttonHover'

function NavButton({ direction, onClick, disabled }) {
  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      aria-label={direction === 'prev' ? 'Previous slide' : 'Next slide'}
      sx={{
        width: 45,
        height: 45,
        borderRadius: '50%',
        p: 0,
        boxSizing: 'border-box',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#fffefa',
        border: `1px solid ${BUTTON_THEME_COLOR}`,
        transition: BUTTON_TRANSITION,
        '&.Mui-disabled': {
          opacity: 0.35,
        },
      }}
    >
      <Box
        component="img"
        src={arrowRightSharpIcon}
        alt=""
        sx={{
          width: 24,
          height: 24,
          display: 'block',
          transform: direction === 'prev' ? 'rotate(180deg)' : 'none',
        }}
      />
    </IconButton>
  )
}

export default function SliderNavButtons({ onPrev, onNext, prevDisabled, nextDisabled, sx = {} }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', ...sx }}>
      <NavButton direction="prev" onClick={onPrev} disabled={prevDisabled} />
      <NavButton direction="next" onClick={onNext} disabled={nextDisabled} />
    </Box>
  )
}
